import type { IconContainerProps } from './typings'

import { IconContainer } from './elements/IconContainer'

export function CheckCircleOutlined(props: IconContainerProps) {
  return (
    <IconContainer {...props}>
      <svg viewBox="0 0 64 64">
        <path
          d="M44.2407 20.213L26.6673 37.7863L17.094 28.2397L13.334 31.9997L26.6673 45.333L48.0006 23.9997L44.2407 20.213ZM32.0006 5.33301C17.2807 5.33301 5.33398 17.2797 5.33398 31.9997C5.33398 46.7197 17.2807 58.6663 32.0006 58.6663C46.7206 58.6663 58.6673 46.7197 58.6673 31.9997C58.6673 17.2797 46.7206 5.33301 32.0006 5.33301ZM32.0006 53.333C20.214 53.333 10.6673 43.7863 10.6673 31.9997C10.6673 20.213 20.214 10.6663 32.0006 10.6663C43.7873 10.6663 53.334 20.213 53.334 31.9997C53.334 43.7863 43.7873 53.333 32.0006 53.333Z"
          fill="#47B882"
        />
      </svg>
    </IconContainer>
  )
}
